<script lang="ts">
  import type { R2REvent } from '$src/types/events';

  const event: R2REvent = window.currentEvent;

  const theme = event.clinicType ? 'orange' : 'green';
</script>

<div class="2xl:fluid-gap-[48] flex flex-col gap-8 lg:gap-12">
  <h1 class="heading-2xl">We hebben je inschrijving ontvangen!</h1>

  <p class="text-16px">
    Bedankt voor je inschrijving. We zien je graag op {new Date(
      event.date.date
    ).toLocaleDateString('nl-NL', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    })} in {event.location.city}.<br />
    Wil je nog een deelnemer aanmelden?
    <a
      href={event.slug}
      class={`link-decoration-${theme} underline underline-offset-[20%]`}
      >Klik dan hier</a
    >
  </p>
</div>
